import React from 'react';
import styled from 'styled-components';
import { boxShadow, colors } from 'styles/theme';
import routes from 'helpers/routes';
import { needHelpJpg } from 'images';
import Button from '../Button';

const Wrapper = styled.div`
  margin-top: 80px;
  background-color: ${colors.white};
  box-shadow: ${boxShadow.big};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
  position: relative;
  color: ${colors.navy};
`;

const Avatar = styled.div`
  height: 88px;
  width: 88px;
  border-radius: 44px;
  border: 4px solid ${colors.white};
  background-size: contain;
  background-image: url(${needHelpJpg});
  background-position: 50% 50%;
  background-repeat: no-repeat;
  position: absolute;
  top: -44px;
`;

const Header = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin: 40px 0px 20px;
`;

const Description = styled.div`
  font-size: 16px;
  margin-bottom: 20px;
`;

const BookCall = styled(Button)`
  background: ${colors.yellow};
  color: ${colors.royal};
  margin-bottom: 20px;
`;

export default () => (
  <Wrapper>
    <Avatar />
    <Header>Need Help?</Header>
    <Description>Get advice from one of our expert marketers.</Description>
    <BookCall to={routes.bookMarketer.index}>Book a Call</BookCall>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/shared/NeedHelp/NeedHelp.jsx